import { env } from './../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {
  availableLocales: string[];

  constructor(private translateService: TranslateService) {
    this.availableLocales = env.availableLocales;
  }

  get locale() {
    const browserLang = this.translateService.getBrowserLang();
    return this.availableLocales.includes(browserLang) ? browserLang : 'en';
  }
}
